module.exports = __webpack_public_path__ + "static/img/11.ef15247.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxopen/11.png
// module id = Vz/W
// module chunks = 1